import React from 'react';

import { JsonLD, withConfig, withGridConfig } from '../common/Block.jsx';
import * as BlogListCell from './BlogListCell.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { Column, Row } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import Format from '../common/Format.jsx';
import { default as Image, ImageSrcSet } from '../common/Image.jsx';
import Kit from '../layout/Kit.jsx';
import Layout from '../common/Layout.jsx';
import { ContentContainer, withPaging } from '../common/List.jsx';
import { Footer, View as LoadingView } from '../common/Loading.jsx';
import PageType from '../common/PageType.jsx';
import ScreenSize from '../common/ScreenSize.jsx';
import Url from '../common/Url.jsx';

const defaultColumnCount = 1;

class _BlogsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleRequestData = this.handleRequestData.bind(this);
        this.handleResponseDataPostProcess = this.handleResponseDataPostProcess.bind(this);
    }

    componentDidMount() {
        this.props.onRegisterRequestDataHandler(this.handleRequestData);
        this.props.onRegisterResponseDataPostProcessHandler(this.handleResponseDataPostProcess);

        if (!this.props.data) {
            this.props.onLoad();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.screenSize != this.state.screenSize) {
            this.setState({
                screenSize: this.props.screenSize
            });
        }
        if (!this.props.builder || !this.props.blockConfig || !prevProps.context) {
            return;
        }
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        if (prevProps.context.maxLimit != blockConfig.maxLimit || prevProps.context.tags != blockConfig.tags) {
            this.props.onReset();
            this.props.onLoad();
        }
    }

    handleRequestData(requestData) {
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        requestData.artistId = this.props.context.artistId;
        requestData.inventoryId = this.props.context.inventoryId;
        requestData.listId = this.props.context.listId;
        requestData.maxLimit = blockConfig.maxLimit;
        requestData.tags = blockConfig.tags;

        if (this.props.builder) {
            requestData.limit = 3;

            let columnCount = parseInt(blockConfig.columnCount, 10);
            if (!columnCount || isNaN(columnCount)) {
                columnCount = defaultColumnCount;
            }
            if (columnCount > 1) {
                requestData.limit = 2 * columnCount
            }

            if (requestData.maxLimit < requestData.limit) {
                requestData.limit = requestData.maxLimit
            }
        }
    }

    handleResponseDataPostProcess(data) {
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        if (blockConfig.maxLimit && data.blogs && data.blogs.length >= blockConfig.maxLimit) {
            data.hasMore = false;
        }
    }

    render() {
        let className, legacy, useCellKit;
        if (this.props.blockConfig && this.props.blockConfig.block) {
            className = 'cont--blog__grid cont--kit__content cont__row--custom';
            useCellKit = this.props.blockConfig.block.useCellKit;
        } else {
            legacy = true;
        }
        if (this.props.data && this.props.data.blogs && this.props.data.blogs.length == 0) {
            if (this.props.builder) {
                return (
                    <ContentContainer type="blog">
                        <EmptyContentPlaceholder containerStyle={this.props.containerStyle} style={this.props.style}>You haven't added any blogs yet. Once you do, you'll see them here.</EmptyContentPlaceholder>
                    </ContentContainer>
                );
            }
            return null;
        }
        const props = this.props;
        let columnCount = props.columnCount;
        let CellComponent, contentConfig;
        let ContainerComponent = React.Fragment;
        if (props.useTokenization || useCellKit != undefined) {
            CellComponent = BlogListCell.BlogCellContainer;
            contentConfig = Defaults.cellDesign(props.config, props.blockConfig, Kit.Context.Cell.Blog);

            if (!legacy) {
                switch (props.screenSize) {
                    case ScreenSize.Mobile:
                        columnCount = props.blockConfig.block.columnsPhone || 2;
                        break;
                    case ScreenSize.Tablet:
                        columnCount = props.blockConfig.block.columnsTablet || 3;
                        break;
                }
            }
        } else if (Layout.isFrancisco(props.config)) {
            CellComponent = CellNews;
            ContainerComponent = Row;
        } else {
            CellComponent = Cell;
        }
        const columnSize = Layout.columnSize(columnCount);
        let content = (
            <React.Fragment>
                <ContentContainer className={className} style={props.style} type="blog">
                    {
                        !props.data &&
                        <LoadingView />
                    }
                    {
                        props.data &&
                        props.data.blogs &&
                        <React.Fragment>
                            <ContainerComponent>
                                {
                                    props.data.blogs.map((d, i) => {
                                        let cell = (
                                            <CellComponent
                                                {...props}
                                                key={d.blogId}
                                                columnCount={columnCount}
                                                columnSize={columnSize}
                                                contentConfig={contentConfig}
                                                data={d}
                                                index={i}
                                                listData={props.data.blogs} />
                                        );
                                        if (!legacy) {
                                            cell = <Column key={d.blogId} className="col--custom" size={columnSize}>{cell}</Column>
                                        }
                                        return cell;
                                    })
                                }
                            </ContainerComponent>
                            <Footer
                                builder={props.builder}
                                hasMore={props.data.hasMore}
                                loading={props.loading}
                                onLoadMore={props.onLoadMore} />
                        </React.Fragment>
                    }
                </ContentContainer>
                <JsonLD
                    baseUrl={this.props.baseUrl}
                    builder={this.props.builder}
                    jsonLD={this.props.jsonLD}
                    path="post"
                    querySub={this.props.querySub} />
            </React.Fragment>
        );
        if (props.containerStyle) {
            content = <div className="cont--kit__wrapper" style={props.containerStyle}>{content}</div>
        }
        return content;
    }
}
const BlogsList =
    withConfig(
        withPaging(
            withGridConfig(
                _BlogsList,
                defaultColumnCount,
                { cell: PageType.Content.BlogCell, columns: 'columnCount' }
            ),
            { path: 'blogs', resultKey: 'blogs' }));

function Cell(props) {
    let image;
    if (props.data.featured) {
        const imageTuples = Image.sizes.map(function (d) {
            return { size: d, url: Image.url(props.data.featured, d, d, 'c_fill') };
        });
        image = (
            <ImageSrcSet
                className="blog__card__img"
                builder={props.builder}
                config={props.config}
                data={{ alt: props.data.title, title: props.data.title }}
                imageTuples={imageTuples} />
        );
    }
    const styleSpacer = { marginBottom: '20px' };
    let style;
    if (props.listData && props.lineSpacing) {
        if (Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount)) {
            style = { marginBottom: props.lineSpacing };
        }
        styleSpacer.marginBottom = props.lineSpacing;
    }
    if (props.columnCount > 1 && props.columnSpacing && props.columnSpacing.value && props.columnSpacing.unit) {
        if (!style) {
            style = {};
        }
        style.marginRight = `${props.columnSpacing.value}${props.columnSpacing.unit}`;
    }
    if (props.builder) {
        if (!style) {
            style = {};
        }
        style.pointerEvents = 'none';
    }
    let additionalClassName = '';
    if (!props.lineSpacing || !props.context || !props.context.inventoryId) {
        additionalClassName = ' m-b-sm';
    }
    const link = Url.getLink('', `post/${props.data.blogId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    return (
        <React.Fragment>
            <div className={`cont__row blog__card${additionalClassName}`} style={style}>
                <div className="col col--4">
                    <a href={link}>
                        <div className="blog__card__img__cont">
                            {image}
                        </div>
                    </a>
                </div>
                <div className="col col--8">
                    <a href={link}>
                        <div className="blog__card__title" style={props.titleStyle}>{props.data.title}</div>
                    </a>
                    <div className={`blog__card__date${additionalClassName}`} style={props.publishedStyle}>{props.data.publishedAt}</div>
                    <div dangerouslySetInnerHTML={{ __html: props.data.excerpt }} style={props.excerptStyle} />
                </div>
            </div>
            <div className="cell--spacer" style={styleSpacer} />
        </React.Fragment>
    );
}

function CellNews(props) {
    let image;
    if (props.data.featured) {
        const imageTuples = Image.sizes.map(function (d) {
            return { size: d, url: Image.url(props.data.featured, d, d, 'c_fill') };
        });
        image = (
            <ImageSrcSet
                className="artist__card__img"
                builder={props.builder}
                config={props.config}
                data={{ alt: props.data.title, title: props.data.title }}
                imageTuples={imageTuples} />
        );
    }
    const link = Url.getLink('', `post/${props.data.blogId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    return (
        <div className="col col--4" style={props.builder ? { pointerEvents: 'none' } : undefined}>
            <figure>
                <a href={link}>
                    {image}
                </a>
                <figcaption>
                    <a href={link} className="news__title--link">
                        <h3 className="news__title font--body">{props.data.title}</h3>
                    </a>
                    <div>
                        <p className="news__meta">
                            <span className="news__date">{Format.Date.getLongMonthYear(props.data.publishedAt)}</span>
                        </p>
                        <hr />
                        <p className="news__excerpt">
                            <span dangerouslySetInnerHTML={{ __html: props.data.excerpt }} /> <a href={link}>read more</a>
                        </p>
                    </div>
                </figcaption>
            </figure>
        </div>
    );
}

export default { Component: BlogsList };